<template>
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-4">
      <div class="card">
        <div style="position:absolute;" class="card-header pl-2 pt-1 p-0">
          <b-tooltip target="button-7"
            ><span class="letter"
              >Total de envíos hechos al centro de salud de enero 2022 a la
              actualidad.</span
            >
          </b-tooltip>
          <i id="button-7" class="feather icon-globe info-color"></i>
        </div>
        <div class="card-body">
          <div class="row align-items-center ">
            <div class="col-3 text-center align-center">
              <h3 class="h3">
                <i class="feather icon-truck fa-2x mr-3"></i>
              </h3>
            </div>
            <div class="col-9 pl-0">
              <span class="font-12 text-uppercase"
                >Enero 2022 - Actualidad</span
              >

              <ul class="list-inline mb-0 mt-1">
                <li>
                  <h4 class="mb-2">
                    {{ numeral(shipmentCount).format("0,0") }}
                  </h4>
                </li>
              </ul>
              <h5 class="font-15">ENVÍOS CON DESTINO AL CENTRO DE SALUD</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-4">
      <div class="card">
        <div style="position:absolute;" class="card-header pl-2 pt-1 p-0">
          <b-tooltip target="button-8"
            ><span class="letter"
              >Total de recetas dispensadas en el centro de salud de enero 2022
              a la actualidad.</span
            >
          </b-tooltip>
          <i id="button-8" class="feather icon-globe info-color"></i>
        </div>
        <div class="card-body">
          <div class="row align-items-center ">
            <div class="col-3 text-center align-center">
              <h3 class="h3">
                <i class="feather icon-user-plus fa-2x"></i>
              </h3>
            </div>
            <div class="col-9 pl-0">
              <span class="font-12 text-uppercase"
                >Enero 2022 - Actualidad</span
              >

              <ul class="list-inline mb-0 mt-1">
                <li>
                  <h4 class="mb-2">
                    {{ numeral(prescriptionCount).format("0,0") }}
                  </h4>
                </li>
              </ul>
              <h5 class="font-15">RECETAS SURTIDAS EN EL CENTRO DE SALUD</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4">
      <div class="card">
        <div style="position:absolute;" class="card-header pl-2 pt-1 p-0">
          <b-tooltip target="button-9"
            ><span class="letter"
              >Total de piezas dispensadas en el centro de salud de enero 2022 a
              la actualidad.</span
            >
          </b-tooltip>
          <i id="button-9" class="feather icon-globe info-color"></i>
        </div>
        <div class="card-body">
          <div class="row align-items-center ">
            <div class="col-3 text-center align-center">
              <h3 class="h3">
                <i class="feather icon-package fa-2x"></i>
              </h3>
            </div>
            <div class="col-9 pl-0">
              <span class="font-12 text-uppercase"
                >Enero 2022 - Actualidad</span
              >
              <ul class="list-inline mb-0 mt-1">
                <li>
                  <h4 class="mb-2">
                    {{ numeral(pieceCount).format("0,0") }}
                  </h4>
                </li>
              </ul>
              <h5 class="font-15">PIEZAS DISPENSADAS EN EL CENTRO DE SALUD</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import gsap from "gsap";

export default {
  data() {
    return {
      numeral: require("numeral"),
      pieceCount: 0,
      prescriptionCount: 0,
      shipmentCount: 0,
    };
  },
  computed: {
    // Extración del state
    ...mapState("branchOffice", {
      modelDetails: "modelDetails",
    }),
  },
  created() {
    gsap.to(this, {
      duration: 0.5,
      pieceCount: this.modelDetails.dispensingProducts,
    });
    gsap.to(this, {
      duration: 0.5,
      shipmentCount: this.modelDetails.shipments,
    });
    gsap.to(this, {
      duration: 0.5,
      prescriptionCount: this.modelDetails.medicalPresciptions,
    });
  },
  watch: {
    "modelDetails.dispensingProducts": {
      handler: function(val) {
        gsap.to(this, { duration: 0.5, pieceCount: val });
      },
    },
    "modelDetails.medicalPresciptions": {
      handler: function(val) {
        gsap.to(this, { duration: 0.5, prescriptionCount: val });
      },
    },
    "modelDetails.shipments": {
      handler: function(val) {
        gsap.to(this, { duration: 0.5, shipmentCount: val });
      },
    },
  },
};
</script>

<style scoped src="@/other/assets/css/app.css"></style>
<style scoped></style>
